// extracted by mini-css-extract-plugin
export default {"icon":"SlashCommandMenu-module__icon--SCiyW","tooltipTarget":"SlashCommandMenu-module__tooltipTarget--sXFPa","dropzone":"SlashCommandMenu-module__dropzone--I4ihS"};